if (!customElements.get('bb-browse-paths')) {
  customElements.define('bb-browse-paths', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const input = this.querySelector('[data-bb-team-input]');
      const search = this.querySelector('[data-bb-team-search]');
      const empty = this.querySelector('[data-bb-team-empty]');
      const chooser = this.querySelector('details');
      const items = Array.from(this.querySelectorAll('[data-bb-team-item]'));
      if (!input || !search || !empty || !chooser) return;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
      const names = new Map(items.map(item => [item, normalize(item.dataset.teamName)]));
      search.hidden = false;
      const update = () => {
        const words = normalize(input.value).split(' ').filter(Boolean);
        let count = 0;
        items.forEach(item => {
          const searchName = names.get(item);
          const terms = searchName.split(' ');
          item.hidden = !words.every(word => word.length <= 3 ? terms.some(term => term.startsWith(word)) : searchName.includes(word));
          if (!item.hidden) count++;
        });
        empty.hidden = count > 0;
      };
      input.addEventListener('input', update);
      input.addEventListener('search', update);
      chooser.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        chooser.open = false;
        chooser.querySelector('summary').focus();
      });
    }
  });
}
